import { observer } from "mobx-react-lite";
import React, { Fragment, useEffect, useState } from "react";
import { useStore } from "../../app/stores/store";
import { Button, Header, Icon, Segment } from "semantic-ui-react";
import MyDateInput from "../../app/common/form/MyDateInput";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { MySelectInput, valor } from "../../app/common/form/MySelectInput";
import {
  SaldosReportes,
  SaldosReportesFormValues,
} from "../../app/models/SaldosReporte";
import "./Operaciones_style.css";
import CreateOperacion from "../Modals/CreateOperacion";
import OperacionesTabla from "./OperacionesTabla";
import { Message } from "semantic-ui-react";
import { TiposTransaccion } from "../../app/common/options/TiposTransaccion";
import { string } from "yup/lib/locale";
import SaldosTabla from "./SaldosTabla";
import SubMenuOPReportes from "../Operaciones/MenuOperaciones";

export default observer(function SaldosReporte() {
  const { SaldosReporteStore, modalStore } = useStore();
  const { loadSaldos, SaldosRegistry } = SaldosReporteStore;
  const { SaldosByCodigo, reporte } = SaldosReporteStore;
  const mensajeData = false;
  // SaldosRegistry.clear()

  const { loading } = SaldosReporteStore;

  function sleep(milliseconds: any) {
    var start = new Date().getTime();
    for (var i = 0; i < 1e7; i++) {
      if (new Date().getTime() - start > milliseconds) {
        break;
      }
    }
  }

  const [SaldosReportes, setSGPersona] = useState<SaldosReportesFormValues>(
    new SaldosReportesFormValues()
  );

  const TiposDeCuentas = [
    { text: "Cursos y Certificaciones", value: "Cursos y Certificaciones" },
    { text: "Asesorías Administrativas", value: "Asesorías Administrativas" },
    {
      text: "Cursos Asistencia Técnica Regional",
      value: "Cursos Asistencia Técnica Regional",
    },
    { text: "Maestrías y Doctorados", value: "Maestrías y Doctorados" },
    { text: "Webinars", value: "Webinars" },
    { text: "TODOS", value: "TODOS" },
  ];

  const validationSchema = Yup.object({
    tipoDeCuenta: Yup.string().required("Obligatorio"),
  });

  function handleFormSubmit(SaldosReportes: SaldosReportesFormValues) {
    loadSaldos(SaldosReportes.tipoDeCuenta);
  }

  return (

    <>
    
      <SubMenuOPReportes />
      <div>
        <div className="header_operaciones">
          <h1>Reporte de saldos</h1>
        </div>
        <br></br>
        <br></br>
        <br></br>
        <div className="buscar_operaciones">
          <Formik
            validationSchema={validationSchema}
            enableReinitialize
            initialValues={SaldosReportes}
            onSubmit={(values) => handleFormSubmit(values)}
          >
            {({ handleSubmit, isValid, isSubmitting, dirty }) => (
              <Form
                className="ui form"
                onSubmit={handleSubmit}
                autoComplete="off"
              >
                <div className="form_buscar_operaciones">
                  <div>
                    <Header size="small" content="Tipo de Cuenta" />
                    <MySelectInput
                      id=""
                      name="tipoDeCuenta"
                      placeholder=" "
                      options={TiposDeCuentas}
                    />
                  </div>
                  <div className="boton_buscar_operaciones">
                    <Button
                      loading={loading}
                      type="submit"
                      content="Generar reporte"
                      style={{ backgroundColor: "#15b3e8", color: "white" }}
                    />
                  </div>
                </div>
              </Form>
            )}
          </Formik>
          <br></br>
          {SaldosReporteStore.dataMessage ? (
            <>
              <Message negative>
                <Message.Header>
                  No hay saldos registrados con ese tipo de cuenta
                </Message.Header>
              </Message>
            </>
          ) : (
            <></>
          )}
        </div>
      </div>

    </>

  
  );
});
